import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ContainerMeasurementsEffects } from 'app/state/container-measurements/container-measurements.effects';
import { containerMeasurementFeature } from 'app/state/container-measurements/container-measurements.reducer';

@NgModule({
    declarations: [],
    imports: [
        StoreModule.forFeature(containerMeasurementFeature),
        EffectsModule.forFeature([ContainerMeasurementsEffects]),
    ],
})
export class ContainerMeasurementStateModule {}
